<section class="container-fluid sts-section sts-form">
    <app-sts-section-header key="sts-signup-header" [errors]="errors">
        Provide key identifiers</app-sts-section-header>
  
    <app-sts-section-body *ngIf="!emailSent" key="wrong-postal-code-one">
      <!-- content is served by CMS -->      
    </app-sts-section-body>

    <app-sts-section-body *ngIf="emailSent" key="wrong-postal-code-end">
      <!-- content is served by CMS -->      
    </app-sts-section-body>
    
  
    <app-sts-lower-bar >
      <button *ngIf="!emailSent" class="sts-btn"               
              type="button"
              routerLink="/" >Cancel
      </button>
      <button *ngIf="!emailSent" class="sts-btn" 
              type="button"
              (click)="generateEmail()"
               >Submit
      </button>
      <button *ngIf="emailSent" class="sts-btn"               
              type="button"
              routerLink="/" >Close
      </button>
    </app-sts-lower-bar>
  
</section>
  
  